module.exports = __webpack_public_path__ + "document-icon-400.236bffa9134c588d1f8a.png";


//////////////////
// WEBPACK FOOTER
// /usr/local/app/src/assets/Template/images/document-icon-400.png
// module id = ../../../../../src/assets/Template/images/document-icon-400.png
// module chunks = 2